import { LogoutOptions } from '@auth0/auth0-react'
import { Browser } from '@capacitor/browser'

import posthog from 'posthog-js'

import { isNativeApp } from '../config/auth0'
import { clearEmailVerificationState } from './emailVerification'

const domain = process.env.REACT_APP_AUTH0_DOMAIN || 'scrubstr.us.auth0.com'

/** Clears per-user email verification overrides before ending the Auth0 session. */
export const prepareLogout = (userId?: string | null): void => {
  if (userId) {
    clearEmailVerificationState(userId)
  }
  posthog.reset()
}

export const getLogoutOptions = (): LogoutOptions => {
  const isMobileDevice = isNativeApp()

  if (!isMobileDevice) {
    return { logoutParams: { returnTo: window.location.origin } }
  }

  return {
    logoutParams: {
      returnTo: `com.scrubstr.app://${domain}/capacitor/com.scrubstr.app/callback`,
    },
    async openUrl(url) {
      await Browser.open({
        url,
        windowName: '_self',
      })
    },
  }
}
